import { useCore } from '@/composables/core'
import { isLocalhost } from '@booksy-com/vue-tools'

// Same condition as the api client in `@/api/client`, so both always agree on proxy mode.
function usesDevProxy (): boolean {
  return Boolean(process.env.VUE_APP_PROXY_LOCALHOST) || isLocalhost(window.location.origin)
}

export function resolveInvopopAdapterUrl (path: string): string {
  if (!path.startsWith('/')) {
    throw new Error('path must start with /')
  }

  const { store } = useCore()
  const country = store.state.app.country

  if (usesDevProxy()) {
    if (!country) {
      throw new Error('app.country is required for invopop-adapter requests in local proxy mode')
    }

    // Goes through the Vite dev proxy: "/proxy--es/..." >>> "https://es.<proxy host>/..."
    // Absolute on purpose: the api client treats urls starting with "/" as service paths and logs
    // "failed to detect service" for the unknown "proxy--es" prefix. Absolute urls skip that check.
    return `${window.location.origin}/proxy--${country}${path}`
  }

  const url = new URL(window.location.origin)

  if (country && !url.hostname.startsWith(`${country}.`)) {
    url.hostname = `${country}.${url.hostname}`
  }

  return `${url.origin}${path}`
}

export function invopopAdapterHeaders (): Record<string, string> {
  const { store } = useCore()
  const accessToken = store.state.identity.accessToken

  if (!accessToken) {
    return {}
  }

  return {
    'X-Access-Token': accessToken,
  }
}
